export default __webpack_public_path__ + "static/media/woman-2.33f2a532.jpg";